var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("home-floating-window", {
    attrs: {
      title: _vm.$t("BulkTechnicalPoint"),
      "pos-x": _vm.position.x,
      "pos-y": _vm.position.y,
      draggable: !_vm.loading && !_vm.dragIsDisabled
    },
    on: {
      close: _vm.closeBulkTP,
      changePosition: function($event) {
        return _vm.$emit("changeBulkTPWindowPosition", $event)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "iconWindows",
        fn: function() {
          return [_c("BulkTPSVG", { staticClass: "floating-container-svg" })]
        },
        proxy: true
      },
      {
        key: "objectDivWindows",
        fn: function() {
          return [
            _c("div", { staticClass: "floating-tool-content" }, [
              _c(
                "div",
                { staticClass: "bulk-tp-objects-div" },
                [
                  _c("bulk-t-p-creation-type-buttons", {
                    attrs: { "selection-type": "line", creatable: true },
                    on: { setType: _vm.setBulkTPType }
                  }),
                  _vm._v(" "),
                  _c("HighlightedBox", {
                    attrs: {
                      "bad-object": _vm.badObject,
                      "is-visible": _vm.showInstruction,
                      message: _vm.currentInstruction
                    }
                  }),
                  _vm._v(" "),
                  _c("bulk-t-p-creation-options", {
                    attrs: {
                      "too-many-points-drawn": _vm.tooManyPointsDrawn,
                      count: _vm.count
                    },
                    on: {
                      "update-distance": function($event) {
                        return _vm.adjustParameters(
                          $event.distance,
                          $event.number
                        )
                      },
                      "update-number": function($event) {
                        return _vm.adjustParameters(
                          $event.distance,
                          $event.number
                        )
                      },
                      "toggle-drag": function($event) {
                        _vm.dragIsDisabled = $event
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("v-checkbox", {
                    staticStyle: { "margin-top": "30px" },
                    attrs: {
                      label: _vm.$tc("pathway_store"),
                      color: "var(--primary-highlight)"
                    },
                    model: {
                      value: _vm.createPathway,
                      callback: function($$v) {
                        _vm.createPathway = $$v
                      },
                      expression: "createPathway"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("home-window-button", {
              attrs: {
                label: _vm.bulkTPLabelButton,
                disabled: _vm.bulkTPButtonDisabled
              },
              on: { buttonClick: _vm.createBulkTP }
            }),
            _vm._v(" "),
            _c("loading-spinner", {
              attrs: {
                active: _vm.loading,
                "is-full-page": true,
                color: "accent"
              },
              on: {
                "update:active": function($event) {
                  _vm.loading = $event
                }
              }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dffa5876", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dffa5876","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/BulkTP/BulkTPWindow.vue
// module id = null
// module chunks = 